import { render, staticRenderFns } from "./ActivatedJunior.vue?vue&type=template&id=31208135"
import script from "./ActivatedJunior.vue?vue&type=script&lang=ts"
export * from "./ActivatedJunior.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports